"use strict";
// Misc Logical Operators: https://docs.mongodb.com/manual/reference/operator/aggregation/rand/#mongodb-expression-exp.-rand
Object.defineProperty(exports, "__esModule", { value: true });
exports.$rand = void 0;
/**
 * Returns a random float between 0 and 1.
 *
 * @param selector
 * @param value
 * @returns {Function}
 */
var $rand = function (obj, expr, options) { return Math.random(); };
exports.$rand = $rand;
